import React from 'react';
import PropTypes from 'prop-types';
import { useCurrentLanguage } from 'tradera-lang/translate';
import { formatPrice } from 'tradera-utils/format';
import { useSelector } from 'react-redux';
import { selectPreferredCurrency } from 'tradera-state/multi-currency/selectors';

const PriceLabel = ({ tagName: TagName, className, price, hasDiscount }) => {
    const { language } = useCurrentLanguage();
    const preferredCurrency = useSelector(selectPreferredCurrency);

    if (!price) {
        return null;
    }

    const formattedPrice = formatPrice(
        price * preferredCurrency.rate,
        language,
        {
            currency: preferredCurrency.code,
            maximumFractionDigits: preferredCurrency.decimals
        }
    );

    return formattedPrice ? (
        <TagName className={`${hasDiscount ? 'text-danger' : ''} ${className}`}>
            {formattedPrice}
        </TagName>
    ) : null;
};
PriceLabel.propTypes = {
    tagName: PropTypes.string,
    className: PropTypes.string,
    price: PropTypes.number,
    hasDiscount: PropTypes.bool
};
PriceLabel.defaultProps = {
    tagName: 'span',
    className: ''
};

export default PriceLabel;
